import React from 'react';
import { Badge } from '../ui/Badge';
type ServerStatus = 'healthy' | 'degraded' | 'offline';
type DecisionStatus = 'allowed' | 'denied';
interface StatusBadgeProps {
  status: ServerStatus | DecisionStatus;
  showDot?: boolean;
}
const statusLabels: Record<ServerStatus | DecisionStatus, string> = {
  healthy: 'Healthy',
  degraded: 'Degraded',
  offline: 'Offline',
  allowed: 'Allowed',
  denied: 'Denied'
};
export function StatusBadge({
  status,
  showDot = true
}: StatusBadgeProps) {
  return <Badge variant={status} dot={showDot} data-id="element-96">
      {statusLabels[status]}
    </Badge>;
}